import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { login_action, forgetPassword_action, updatePassword_action, getCredential_action, forgetUpdatePassword_action, forgetGetOtp_action } from '../../actions/authAction/auth_action';
import Modal from 'react-bootstrap/Modal';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage, toastError } from '../../utils/constants'
import Header from '../../common_components/Header';
import { emailValidator, loginPasswordValidator, loginUsernameValidator, otpValidator, confirmPasswordValidator } from '../../utils/Validator'
// import Modal from "react-modal";


class ChangePassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            matchPass: '',
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            is_showoldPassword: false,
            is_shownewPassword: false,
            is_showconfirmPassword: false,

            oldPassErr: '',
            newPassErr: '',
        }
        this.getUserDetails = this.getUserDetails.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)

    }

    componentDidMount() {
        this.getUserDetails()
    }
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default form submission behavior if it's wrapped in a form
            this.handleSubmit(); // Call submit on Enter key press
        }
    };

    getUserDetails() {
        // event.preventDefault();
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .getCredential_action()
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({
                        matchPass: data.data[0].Password,
                        isLoading: false
                    })
                }
            })
    }

    handleSubmit() {
        // event.preventDefault();
        const { oldPassword, newPassword, matchPass, confirmPassword } = this.state

        if (newPassword != ' ' && confirmPassword != ' ' && newPassword != '' && confirmPassword != '') {
            if (newPassword.length >= 8) {
                if (newPassword == confirmPassword) {
                    if (oldPassword == matchPass) {
                        if (oldPassword != newPassword) {
                            this.setState({ isLoading: true })
                            this.props
                                .updatePassword_action(oldPassword.trim(), newPassword.trim())
                                .then((data) => {
                                    console.log(data)
                                    if (data.error != 1) {
                                        this.setState({ isLoading: false })
                                        sessionStorage.clear()
                                        this.props.navigate('/login')
                                    }
                                    else {
                                        this.setState({ isLoading: false })
                                        toast.error(data.msg, {
                                            theme: 'colored',
                                            autoClose: 3000,
                                            hideProgressBar: true,
                                        })
                                    }
                                })
                                .catch((e) => {
                                    console.log(e);
                                });
                        } else {
                            this.setState({ newPassErr: 'New Password cannot be same as Old password' })
                            toast.error('New Password cannot be same as Old password', {
                                theme: 'colored',
                                autoClose: 1000,
                                hideProgressBar: true,
                            })
                        }
                    } else {
                        this.setState({ oldPassErr: 'Invalid Old Password' })
                        toast.error('Invalid Old Password', {
                            theme: 'colored',
                            autoClose: 1000,
                            hideProgressBar: true,
                        })
                    }
                } else {
                    this.setState({ newPassErr: 'Passwords dont match' })
                    toast.error('Passwords dont match', {
                        theme: 'colored',
                        autoClose: 1000,
                        hideProgressBar: true,
                    })
                }
            } else {
                this.setState({ newPassErr: 'Minimum 8 characters' })
                toast.error('Minimum 8 characters', {
                    theme: 'colored',
                    autoClose: 1000,
                    hideProgressBar: true,
                })
            }
        }
        else {
            this.setState({ newPassErr: 'Passwords cannot be blank' })
            toast.error('Passwords cannot be blank', {
                theme: 'colored',
                autoClose: 1000,
                hideProgressBar: true,
            })
        }
    }

    handleObscure(mode) {
        const { is_showoldPassword, is_shownewPassword, is_showconfirmPassword } = this.state
        if (mode == 1) {
            this.setState({ is_showoldPassword: !is_showoldPassword })
        } else if (mode == 2) {
            this.setState({ is_shownewPassword: !is_shownewPassword })
        } else if (mode == 3) {
            this.setState({ is_showconfirmPassword: !is_showconfirmPassword })
        }
    }

    render() {
        const { userName, oldPassword, emailVerified, verifyEmail, isOTPverified, isLoading, isOpen, is_showpass, is_forgotPassword, is_verifyEmail, getOtp, forgetNewPass, forgetConfirmPass, is_loginForgotPassword, is_showoldPassword, is_shownewPassword, is_showconfirmPassword } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <section class="Login_page" style={{ padding: 0 }} >
                    <div>
                        <img src="assets/img/login_img.jpg" style={{ width: "100%" }} />
                        <div class="container" >
                            <div class="row" data-aos="fade-up" data-aos-delay="500">
                                <div class="col-md-12 col-sm-12">
                                    <div class="login_main_div">
                                        <div class="login-wrap">
                                            <img src="assets/img/logo_2.png" class="logo_img_css" />
                                            <h2>Change Password</h2>
                                            <div class="form">
                                                <div className='mb-4'>
                                                    <input type={is_showoldPassword ? "text" : "password"}
                                                        placeholder="Old Password"
                                                        style={{ padding: "15px 30px 15px 15px", marginBottom: 0 }}
                                                        value={this.state.oldPassword}
                                                        onKeyDown={this.handleKeyDown}
                                                        onChange={(e) => this.setState({ oldPassword: e.target.value, oldPassErr: '' })} required />
                                                    <i
                                                        className={!is_showoldPassword ? "fa fa-eye-slash login-view-eye" : "fa fa-eye login-view-eye"}
                                                        onClick={() => this.handleObscure(1)}
                                                    />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{this.state.oldPassErr}</span>}
                                                </div>

                                                <div className='mb-4'>
                                                    <input type={is_shownewPassword ? "text" : "password"}
                                                        placeholder="New Password"
                                                        style={{ padding: "15px 0px 15px 15px", marginBottom: 0 }}
                                                        value={this.state.newPassword}
                                                        onKeyDown={this.handleKeyDown}
                                                        onChange={(e) => this.setState({ newPassword: e.target.value, newPassErr: '' })} required />
                                                    <i
                                                        className={!is_shownewPassword ? "fa fa-eye-slash login-view-eye" : "fa fa-eye login-view-eye"}
                                                        onClick={() => this.handleObscure(2)}
                                                    />
                                                    {<span className='text-danger text-start text-left d-block '>{this.state.newPassErr}</span>}
                                                </div>

                                                <div className='mb-4'>
                                                    <input type={is_showconfirmPassword ? "text" : "password"}
                                                        placeholder="Confirm Password"
                                                        style={{ padding: "15px 30px 15px 15px", marginBottom: 0 }}
                                                        value={this.state.confirmPassword}
                                                        onKeyDown={this.handleKeyDown}
                                                        onChange={(e) => this.setState({ confirmPassword: e.target.value })} required />
                                                    <i
                                                        className={!is_showconfirmPassword ? "fa fa-eye-slash login-view-eye" : "fa fa-eye login-view-eye"}
                                                        onClick={() => this.handleObscure(3)}
                                                    />
                                                </div>

                                                <button onClick={() => this.handleSubmit()} class="btn btn-primary login_btn"> Submit </button>
                                                <a class="" style={{ cursor: 'pointer' }} onClick={() => this.props.navigate(-1)}>Back</a>
                                            </div>


                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </>)
    }
}

export default withRouter(connect(null, { login_action, forgetPassword_action, forgetUpdatePassword_action, getCredential_action, updatePassword_action, forgetGetOtp_action })(ChangePassword));
